import { SettingsModuleType, MineMVBid, MineMCBid } from './interface';

const Statistics = Mach.requireModule('Statistics');

// 自动上报PV
const lxPv = (cid: string, lab: object) => {
  if (!cid) {
    return;
  }
  Statistics.pv(cid, lab);
};

// 手动上报pv：个人中心使用
const lxPvm = (cid: string, lab: object) => {
  if (!cid) {
    return;
  }
  Statistics?.pvm?.(cid, lab);
};

// 上报PD：个人中心使用
const lxPd = () => {
  Statistics.pd();
};

const lxViewReport = (cid: string, bid: string, lab: object) => {
  if (!bid) {
    return;
  }
  Statistics?.view(cid, bid, lab);
};

const lxClickReport = (cid: string, bid: string, lab: object) => {
  if (!bid) {
    return;
  }
  Statistics?.click(cid, bid, lab);
};

const lxLabForCell = (item) => {
  const itemData = item?.data;
  const { type } = itemData || {};
  let lab = {};
  switch (type) {
    case SettingsModuleType.mycoupons:
      lab = {};
      break;

    default:
      break;
  }
  return lab;
};

const lxViewReportForCell = (cid: string, item: any) => {
  const itemData = item?.data;
  let { type, logData } = itemData || {};

  if ((typeof logData) == 'string') {
    logData = JSON.parse(logData);
  }

  const bid = MineMVBid[type];
  const lab = logData || {};
  lxViewReport(cid, bid, lab);
};

const lxClickReportForCell = (cid: string, item: any) => {
  const itemData = item.data;
  let { type, logData } = itemData || {};
  const bid = MineMCBid[type];

  if ((typeof logData) == 'string') {
    logData = JSON.parse(logData);
  }

  const lab = logData || {};
  lxClickReport(cid, bid, lab);
};
export {
  lxPv, lxPvm, lxViewReport, lxClickReport, lxClickReportForCell, lxViewReportForCell, lxPd
};
